/**
 * <SubscriptionLine> — un glyphe et une phrase (molecule, L0.1).
 *
 * La ligne datée de la carte d'état (« Prochain paiement : 119 € le 5 octobre 2026 ») et la
 * promesse de la carte « Et ensuite ? » (« Jusqu'à 3 mois de pause ») sont la même forme : les
 * deux cartes la partagent plutôt que de la redessiner chacune.
 *
 * Le glyphe reste haut quand la phrase se replie sur deux lignes — d'où `align="start"`.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { type SemanticColorKey } from "../../theme/tokens/colors"
import { Icon } from "../../atoms/icons/Icon"
import { Row } from "../../atoms/containers/Row"
import { Text } from "../../atoms/typography/Text"
import { type UISubscriptionLine } from "../../../ports/primary/ui/types"

export type SubscriptionLineProps = {
    line: UISubscriptionLine
    /** Couleur du glyphe — défaut `primary`. */
    iconColor?: SemanticColorKey
    testID?: string
}

export function SubscriptionLine(props: SubscriptionLineProps) {
    const { line, iconColor = "primary", testID } = props

    return (
        <Row gap="2" align="start" testID={testID}>
            <Icon name={line.icon} size={16} color={iconColor} />
            <Text size="text-sm" style={styles.text}>
                {line.text}
            </Text>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    // La phrase se replie plutôt que de pousser le glyphe hors de la carte.
    text: { flexShrink: 1 },
}))
